import createBlocker from './utils/create-blocker';
import createState from './utils/create-state';
import getInitialConfig from './utils/get-initial-config';
import prepareElementToHydration from './utils/prepare-element';

/**
 * Initiates lazy hydration by setup.
 * @param setup setup object (keys are selectors, values are configs).
 */
 export default function(setup) {
    const selectors = Object.keys(setup);

    for (const selector of selectors) {
        const $elements = document.querySelectorAll(selector);

        if ($elements.length) {
            const elementsSetup = setup[selector];

            for (let i = 0, len = $elements.length; i < len; i++) {
                const $element = $elements[i];

                createState($element);
                prepareElementToHydration($element, elementsSetup);

                const modules = $element.dataset.modules.split(' ');

                if (modules.length > 1) {
                    const hydrationTypes = $element.dataset.hydration.split(' ');
                    let blockersCreated = 0;

                    for (let moduleIndex = $element.hydrationState.blockersCreated, modulesLen = modules.length; moduleIndex < modulesLen; moduleIndex++) {
                        const moduleName = modules[moduleIndex];
                        const hydrationType = hydrationTypes[moduleIndex] || hydrationTypes[0];

                        createBlocker(
                            $element,
                            hydrationType,
                            () => {
                                import(LAZY_HYDRATION_PATH + moduleName).then(({ default: hydrate}) => {
                                    hydrate({ $element, initialConfig: getInitialConfig($element, moduleName, elementsSetup), hydrationType });
                                });
                            }
                        );
                        blockersCreated++;
                    }

                    $element.hydrationState.blockersCreated += blockersCreated;
                } else {
                    const moduleName = $element.dataset.modules;
                    const hydrationType = $element.dataset.hydration || 'whenVisible';

                    createBlocker(
                        $element,
                        hydrationType,
                        () => {
                            import(LAZY_HYDRATION_PATH + moduleName).then(({ default: hydrate}) => {
                                hydrate({ $element, initialConfig: getInitialConfig($element, moduleName, elementsSetup), hydrationType });
                            });
                        }
                    );
                    $element.hydrationState.blockersCreated++;
                }
            }
        }
    };
}